var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 42",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2060-Digital-Logo-Horizontal-Gradient-Green-White",
    clipPath: "url(#clip0_3601_966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "url(#paint0_linear_3601_966)",
    d: "M73.82.1c-5.53 0-11.4 3.96-11.4 11.28v3a8.96 8.96 0 0 0-7.8-4.46l-.7.01 6.77-8.78.21-.27h-8.75L43.49 11.9c-.5.72-.93 1.47-1.31 2.24V11.3C42.18 4.92 37.3.1 30.86.1c-4.06 0-8.31 2.15-10.28 6.2-1.17-3.54-4.77-6.2-9.7-6.2C4.28.1 0 4.58 0 11.57h7.21c.16-3.23 1.32-4.73 3.4-4.73 1.65 0 2.8 1.18 2.8 2.92 0 2.3-1.83 5.37-5.2 8.8-1.64 1.7-4.27 3.8-7.92 6.2v5.93H15l4.67-5.94h-.06l-8.85-.02c4.34-3.75 7.15-7 8.71-10.03v5.37c0 6.5 4.94 11.4 11.48 11.4 5.04 0 9.02-2.88 10.55-7.25 1.6 4.44 5.74 7.24 10.97 7.24s9.09-2.85 10.73-7.14c1.62 4.27 5.7 7.14 10.7 7.14 6.52 0 11.25-4.79 11.25-11.39V11.3C85.14 4.92 80.27.11 73.82.11ZM34 20.74c0 1.84-.55 4.02-3.18 4.02-2 0-3.18-1.5-3.18-4.02v-9.85c0-2.48 1.22-4.02 3.18-4.02 2.63 0 3.18 2.19 3.18 4.02v9.85Zm18.22 4.02c-2.36 0-4-1.9-4-4.16a3.92 3.92 0 0 1 4-3.96 4.06 4.06 0 0 1 4.16 4.08c0 2.3-1.8 4.04-4.16 4.04Zm24.74-4.02c0 1.84-.55 4.02-3.18 4.02-2 0-3.18-1.5-3.18-4.02v-9.85c0-2.48 1.22-4.02 3.18-4.02 2.63 0 3.18 2.19 3.18 4.02v9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "url(#paint1_linear_3601_966)",
    d: "M110.27 2.02C108.1.79 105.02.1 101.17.1h-10.6v31.35h11.14c9.7 0 15.74-5.34 15.74-15.67 0-6.4-2.77-11.23-7.18-13.77Zm-8.19 22.72h-3.57V6.85h3.62c4.57 0 7.39 3.39 7.39 8.98 0 5.6-2.86 8.91-7.44 8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "url(#paint2_linear_3601_966)",
    d: "M126.71.1h-6.97v5.36h6.97V.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fill: "url(#paint3_linear_3601_966)",
    d: "M126.71 7.94h-6.97v23.52h6.97V7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fill: "url(#paint4_linear_3601_966)",
    d: "M147.26 10.13h-.08c-1.13-1.82-3.44-2.96-6.46-2.96C134 7.17 129 12.63 129 19.83s4.91 12.36 11.72 12.36c2.85 0 5.45-1.27 6.5-3.51v.68c0 4.27-2.14 6.6-5.66 6.6-1.73 0-3.28-.6-4.08-2.33h-8.06c.6 4.5 4.87 8.26 11.46 8.26 5.84 0 10.41-2.5 12.1-5.76.83-1.6 1.25-4.02 1.25-7.2v-21h-6.97v2.2Zm-5.75 15.5c-3.36 0-5.58-2.75-5.58-6.06 0-3.3 2.47-5.84 5.58-5.84 3.4 0 5.7 2.63 5.7 6.05 0 3.43-2.3 5.85-5.7 5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fill: "url(#paint5_linear_3601_966)",
    d: "M163.52 7.94h-6.97v23.52h6.97V7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fill: "url(#paint6_linear_3601_966)",
    d: "M163.52.1h-6.97v5.36h6.97V.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fill: "url(#paint7_linear_3601_966)",
    d: "M176.25.1h-6.98v7.84h-3.44v5.35h3.44v18.17h6.97V13.3h3.36V7.94h-3.35V.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fill: "url(#paint8_linear_3601_966)",
    d: "M198.72 10.45h-.08c-1.34-2.17-3.99-3.3-6.84-3.3-6.68 0-11.67 5.58-11.67 12.53 0 6.94 4.78 12.58 11.67 12.58 3.06 0 5.83-1.27 6.84-3.35h.08v2.55h6.97V7.95h-6.97v2.5Zm-5.83 15.24a5.85 5.85 0 0 1-5.8-5.93c0-3.26 2.53-6.05 5.72-6.05a6 6 0 0 1 5.91 5.97 5.9 5.9 0 0 1-5.83 6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fill: "url(#paint9_linear_3601_966)",
    d: "M208.03.1v31.36H215V.11h-6.97Zm6.2 30.6h-5.44a30.27 30.27 0 0 0 5.45-5.96v5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fill: "url(#paint10_linear_3601_966)",
    d: "M214.24 30.7h-5.45a30.27 30.27 0 0 0 5.45-5.96v5.95Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3601_966",
    x1: 44.87,
    x2: 41.24,
    y1: -6.04,
    y2: 27.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40B449"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3601_966",
    x1: 105.33,
    x2: 101.7,
    y1: -9.35,
    y2: 38.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3601_966",
    x1: 124.02,
    x2: 120.39,
    y1: -7.95,
    y2: 40.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3601_966",
    x1: 125.27,
    x2: 121.64,
    y1: -7.85,
    y2: 40.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3601_966",
    x1: 143.92,
    x2: 140.29,
    y1: -6.45,
    y2: 41.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3601_966",
    x1: 161.87,
    x2: 158.24,
    y1: -5.1,
    y2: 43.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3601_966",
    x1: 160.62,
    x2: 156.99,
    y1: -5.19,
    y2: 43.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3601_966",
    x1: 173.81,
    x2: 170.18,
    y1: -4.2,
    y2: 44.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3601_966",
    x1: 194.97,
    x2: 191.34,
    y1: -2.6,
    y2: 45.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3601_966",
    x1: 212.78,
    x2: 209.15,
    y1: -1.26,
    y2: 46.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3601_966",
    x1: 214.18,
    x2: 211.28,
    y1: 22.39,
    y2: 31.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40B449"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3601_966"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .1h215v41.8H0z"
  })))));
};
export default SvgLogo;